import type {
  CompanyProfileUpsertInput,
  ContractTemplateCollectionRecord,
  CustomerCategoryUpsertInput,
  PickDirectoryInput,
  ThemeBridgeContract,
  ThemeBridgeStatusRecord,
  WorkspaceIntegrationSecretsUpdate,
  WorkspaceLocalEnvironmentSecretsUpdate,
  WorkspacePaymentSecretsUpdate,
  WorkspaceSettingsUpdate
} from '@shared/types';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function getWorkspaceSettings() {
  return getDesktopApi().settings.getWorkspaceSettings();
}

export async function updateWorkspaceSettings(payload: WorkspaceSettingsUpdate) {
  return getDesktopApi().settings.updateWorkspaceSettings(payload);
}

export async function updateWorkspaceLocalEnvironmentSecrets(payload: WorkspaceLocalEnvironmentSecretsUpdate) {
  return getDesktopApi().settings.updateWorkspaceLocalEnvironmentSecrets(payload);
}

export async function updateWorkspacePaymentSecrets(payload: WorkspacePaymentSecretsUpdate) {
  return getDesktopApi().settings.updateWorkspacePaymentSecrets(payload);
}

export async function updateWorkspaceIntegrationSecrets(payload: WorkspaceIntegrationSecretsUpdate) {
  return getDesktopApi().settings.updateWorkspaceIntegrationSecrets(payload);
}

export async function testOblioConnection() {
  return getDesktopApi().settings.testOblioConnection();
}

export async function refreshOblioNomenclature() {
  return getDesktopApi().settings.refreshOblioNomenclature();
}

export async function listCompanyProfiles() {
  return getDesktopApi().settings.listCompanyProfiles();
}

export async function saveCompanyProfile(payload: CompanyProfileUpsertInput) {
  return getDesktopApi().settings.saveCompanyProfile(payload);
}

export async function listCustomerCategories() {
  return getDesktopApi().settings.listCustomerCategories();
}

export async function saveCustomerCategory(payload: CustomerCategoryUpsertInput) {
  return getDesktopApi().settings.saveCustomerCategory(payload);
}

export async function listContractTemplates(): Promise<ContractTemplateCollectionRecord> {
  return getDesktopApi().contracts.listContractTemplates();
}

export async function getWordPressBridgeStatus(): Promise<ThemeBridgeStatusRecord> {
  return getDesktopApi().settings.getWordPressBridgeStatus();
}

export async function refreshWordPressBridgeStatus(): Promise<ThemeBridgeStatusRecord> {
  return getDesktopApi().settings.refreshWordPressBridgeStatus();
}

export async function getWordPressBridgeContract(): Promise<ThemeBridgeContract> {
  return getDesktopApi().settings.getWordPressBridgeContract();
}

export async function pickDirectory(payload: PickDirectoryInput): Promise<string | null> {
  return getDesktopApi().settings.pickDirectory(payload);
}
